import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import App from './App';
import Preparing from './Preparing';
export default function MainEntry() {
  return (
    <Router>
      <Switch>
        <Route path="/anniversary/2021408">
          <App />
        </Route>
        <Route path="/anniversary/2021319">
          <Preparing />
        </Route>
      </Switch>
    </Router>
  );
}
